import React, { useRef } from 'react';
import { Modal, Row, Col, Container, Form } from 'react-bootstrap';
import SigniteButton from '../../ui-elements/signite-button/signiteButton';
import './addClientUser.css';
import { Formik } from 'formik';
import ClientUserService from '../../../services/client-services/clientUserService';

const initialValues = {};
export const AddClientUserDialog = ({ show, setShow, flowConfig }) => {
  let componentRef = useRef(null);
  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title
          style={{ textAlign: 'center', width: '100%', color: '#2D3E50', fontFamily: 'Poppins', fontWeight: 600 }}
        >
          Add User
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="forgot-password-body">
        <Formik
          initialValues={initialValues}
          innerRef={componentRef}
          enableReinitialize="true"
          onSubmit={async (data) => {
            onSubmit(data, 'personal-details');
          }}
        >
          {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {
            let addClientUser = () => {
              ClientUserService.addClientUser(values)
                .then((data) => alert('Client User added successfully.'))
                .catch((err) => {
                  setShow(false);
                  alert(`Error occured while adding user: ${err.message}`);
                  setShow(true);
                });
            };
            return (
              <Container>
                <Row className="d-flex align-items-center justify-content-center">
                  <Row>
                    <Col>
                      <Form.Label>Name</Form.Label>
                      <Form.Control className="" name="name" onChange={handleChange} value={values.name}></Form.Control>
                    </Col>
                    <Col>
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        className=""
                        name="phoneNumber"
                        onChange={handleChange}
                        value={values.phoneNumber}
                      ></Form.Control>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Work Email ID</Form.Label>
                      <Form.Control
                        className=""
                        name="emailId"
                        onChange={handleChange}
                        value={values.emailId}
                      ></Form.Control>
                    </Col>
                    <Col>
                      <Form.Label>Role</Form.Label>
                      <Form.Select className="" name="clientRole" onChange={handleChange} value={values.clientRole}>
                        <option>--Select--</option>
                        <option>ADMIN</option>
                        <option>PRIMARY</option>
                        <option>USER</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Row>
                <Row>
                  <Col className="p-2 d-flex align-items-center justify-content-center">
                    <SigniteButton
                      variant={'outline-primary'}
                      className="ml-2 mt-3 p-3"
                      onClick={flowConfig && flowConfig.verify}
                    >
                      Cancel
                    </SigniteButton>
                    <SigniteButton variant={'primary'} className="mt-3 p-3" onClick={addClientUser}>
                      Add User
                    </SigniteButton>
                  </Col>
                </Row>
              </Container>
            );
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
